<div class="flex flex-col pr-2 pl-2 md:pl-6">
  <h2 #templatesTop class="title-large text-primary mb-1" data-testid="templates-title">{{ 'Blueprints' | translate }}</h2>
  <p class="body-medium text-on-surface-variant mb-4 md:mb-8" data-testid="templates-description">{{ 'Change your default blueprint type, how you sign your documents, and more' | translate }}</p>

  <!-- Default document types -->
  <div class="flex flex-col lg:flex-row items-start">
    <div class="w-full lg:w-1/3 mb-4 md:mb-0">
      <div class="w-4/5">
        <div class="label-xlarge text-on-surface-variant">{{ 'Default types' | translate }}</div>
        <div class="body-medium text-outline">{{ 'These are the default blueprints that will be pre-selected each time you complete a consultation' | translate }}</div>
      </div>
    </div>
    <div class="w-full lg:w-2/3">
      <div class="w-full lg:w-4/5">

        <!-- Template cards grid -->
        <div class="flex flex-col gap-3" data-testid="templates-list">
      
          <div
            *ngFor="let template of (showAll ? userTemplates : userTemplates.slice(0, 3))"
            class="bg-on-primary border border-surface-varient rounded-lg px-4 flex flex-col justify-center min-h-16"
            data-testid="template-card"
          >
            <h3 class="body-large text-on-surface">
              {{ template.title }}
            </h3>
          </div>
      
        </div>

        <div class="flex justify-end mt-3" *ngIf="userTemplates.length > 3">
          <button
            class="!h-10 low-padding"
            mat-stroked-button
            type="button"
            data-testid="view-more-templates-button"
            (click)="toggleTemplates()"
          >
            {{ (showAll ? 'View less' : 'View more') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div
    class="flex flex-col lg:flex-row items-start pt-6 pb-6"
    [class.sticky]="!showNoteGenerationSettings"
    [class.bottom-0]="!showNoteGenerationSettings"
    [class.z-10]="!showNoteGenerationSettings"
    [class.bg-surface-container-lowest]="!showNoteGenerationSettings">
    <div class="hidden lg:block lg:w-1/3"></div>
    <div class="w-full lg:w-2/3 flex">
      <div class="w-full lg:w-4/5 flex flex-col items-end justify-end">
        <button class="!h-10"
          mat-stroked-button 
          color="secondary" 
          type="button"
          (click)="openTemplateSelector()"
          data-testid="browse-templates-button">
          <mat-icon svgIcon="plus"/>
          {{ 'Browse more' | translate }}
        </button>
      </div>
    </div>
  </div>

  @if (showNoteGenerationSettings) {
    <div class="border-t border-surface-container mb-6"></div>
    <app-default-style-settings></app-default-style-settings>
  }
